.message {
  font-style: italic;
  padding: 8px;
}

.info {
  background: var(--primary-100);
  color: var(--color-ffffff);
}

.success {
  background: var(--secondary-100);
  color: var(--color-ffffff);
}

.error {
  background: var(--color-c2436f);
  color: var(--color-ffffff);
}

.warning {
  background: var(--warning-60);
  color: var(--color-ffffff);
}
